import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import { SoftwareName } from "@/model/data/updates/SoftwareName";
import * as routes from "@/router/routes";
import { RootState } from "@/store";
import _ from "lodash";
import { ApplicationState } from ".";
import menu from "./data/menu";

export default {
    /**
     * Getter per il menu disponibile a seconda delle licenze, dei privilegi, etc...
     */
    availableMenu: (state: ApplicationState, getters, rootState: RootState) => {
        let resultMenu = [];

        const licenseData = rootState.license.licenseModules;

        /**
         * Pre requisiti
         */

        // controllo siano state caricate le licenze
        if (!rootState.license.licenseModules) return [];

        // controllo siano stati caricati i diritti di questo utente
        if (!rootState.authMod.currentUser.profile.privileges) return [];

        // ciclo su tutti gli endpoint del menu
        menu.forEach((m) => {
            const menuToAdd = { ...m };

            // azzero eventuali figli, quelli li controllo successivamente
            menuToAdd.children = [];

            // controllo tutti i moduli necessari per questo menu
            let canAdd = true;
            m.requiredLicenseModules.forEach((module) => {
                canAdd = canAdd && licenseData.isAvailable(module);
            });

            // controllo se l'utente corrente ha i privilegi necessari
            canAdd =
                canAdd && (m.requiredPrivileges == ClientPrivileges.None || rootState.authMod.currentUser.profile.privileges.and(m.requiredPrivileges) != ClientPrivileges.None);

            // se posso aggiungerlo controllo eventuali figli
            if (canAdd) {
                m.children.forEach((child) => {
                    let canAddChild = true;

                    // controllo i moduli licenza
                    child.requiredLicenseModules.forEach((module) => {
                        canAddChild = canAddChild && licenseData.isAvailable(module);
                    });

                    // controllo se l'utente corrente ha i privilegi necessari
                    canAddChild =
                        canAddChild &&
                        (child.requiredPrivileges == ClientPrivileges.None ||
                            rootState.authMod.currentUser.profile.privileges.and(child.requiredPrivileges) != ClientPrivileges.None);

                    if (child.name == "Organizations Licenses" && !state.isCloud && process.env.NODE_ENV != "development") canAddChild = false;

                    if (canAddChild) menuToAdd.children.push(child);
                });

                resultMenu.push(menuToAdd);
            }
        });

        /**
         * Rimuovo l'endpoint per il debug se ho compilato in production
         */
        if (process.env.NODE_ENV == "production") {
            _.remove(resultMenu, function (v) {
                return v.path == routes.Debug;
            });
            resultMenu.forEach((m) => {
                if (m.children) {
                    _.remove(m.children, function (v) {
                        return v.path == routes.Debug;
                    });
                }
            });
        }
        return resultMenu;
    },

    /**
     * Shortcut presenti nella home
     */
    homeShortcuts: (state, getters) => {
        let res = [];

        getters.availableMenu.forEach((m) => {
            if (m.isHomeShortcut) res.push(m);

            if (m.children && m.children.length > 0) {
                m.children.forEach((c) => {
                    if (c.isHomeShortcut) res.push(c);
                });
            }
        });
        return res;
    },

    availableSoftwareNames: (state: ApplicationState) => {
        let softwareList = [];
        state.availableSoftwareVersions.forEach((obj: SoftwareFilter) => {
            let swType = obj.updateType;
            if (swType == UpdateTypeEnum.ThirdPartySoftware)
                obj.versionsList.forEach((v: NamedSoftwareVersion) => {
                    if (!softwareList.some((sw: SoftwareName) => sw.name == v.name)) softwareList.push(new SoftwareName(swType, v.name));
                });
            else if (obj.versionsList[0]) softwareList.push(new SoftwareName(swType, obj.versionsList[0].name));
        });
        return softwareList;
    },
};
